import '../../App.css';
import { useContext, useEffect } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import {
    Chart as ChartJS,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
} from 'chart.js';
import { Scatter } from 'react-chartjs-2';

function ModalEditarSistema({ currentPage }) {
    const { EditarSistema, EdicaoSistema, setEdicaoSistema, ListaSistemas, setModalEditarSistema, Permissao, setError, ObterGraficoMatrizTimeSistema, GraficoMatrizTimeSistema, ListarImpactoNegocio, ImpactoNegocio } = useContext(ApiContext)
    const { ListaFornecedor, Fornecedores } = useContext(ServicoContext)
    const { btnVer, btnCriar, theme, chartRef } = useContext(StyleContext)

    const editar = (e) => {
        if (e) e.preventDefault();
        if (!EdicaoSistema.nome) {
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        EditarSistema(currentPage)
            .then(() => {
                setModalEditarSistema(false)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const handleChange = (event) => {
        setEdicaoSistema({ ...EdicaoSistema, [event.target.name]: event.target.value })
    }

    useEffect(() => {
        ListaSistemas()
        ListaFornecedor()
        ObterGraficoMatrizTimeSistema()
        ListarImpactoNegocio()
    }, [])

    const quadrants = {
        id: 'quadrants',
        beforeDraw(chart, args, options) {
            const { ctx, chartArea: { left, top, right, bottom }, scales: { x, y } } = chart;

            const midX = x.getPixelForValue((x.min + x.max) / 2);
            const midY = y.getPixelForValue((y.min + y.max) / 2);

            ctx.save();

            ctx.fillStyle = options.topLeft;
            ctx.fillRect(left, top, midX - left, midY - top);
            ctx.fillStyle = options.topRight;
            ctx.fillRect(midX, top, right - midX, midY - top);
            ctx.fillStyle = options.bottomRight;
            ctx.fillRect(midX, midY, right - midX, bottom - midY);
            ctx.fillStyle = options.bottomLeft;
            ctx.fillRect(left, midY, midX - left, bottom - midY);

            ctx.fillStyle = options.textColor || '#000000';
            ctx.font = '12px sans-serif';

            ctx.fillText("Tolerar", left + 10, top + 20);
            ctx.fillText("Investir", midX + 10, top + 20);
            ctx.fillText("Migrar", midX + 10, midY + 20);
            ctx.fillText("Eliminar", left + 10, midY + 20);

            ctx.restore();
        },
    };

    ChartJS.register(PointElement, LinearScale, Tooltip, Legend, quadrants);

    const gerarDatasetsMatrizTime = (dado) => {
        if (!dado) return [];

        let x = dado.x;
        let y = dado.y;

        const margemX = 0.5;
        const margemY = 1.5;

        x = Math.max(margemX, Math.min(25 - margemX, dado.x));
        y = Math.max(margemY, Math.min(45 - margemY, dado.y));

        return [
            {
                data: [{ x, y, originalX: dado.x, originalY: dado.y, text: dado.text }],
                backgroundColor: dado.cor,
                pointRadius: 10,
            }
        ];
    };

    const data = {
        datasets: gerarDatasetsMatrizTime(GraficoMatrizTimeSistema),
    };

    const options = {
        plugins: {
            quadrants: {
                topLeft: "rgba(138, 181, 78, 0.1)",
                topRight: "rgba(254, 242, 242, 0.2)",
                bottomLeft: "rgba(219, 244, 255, 0.2)",
                bottomRight: "rgba(254, 252, 232, 0.2)",
                textColor: theme == 'dark' ? '#52525b' : '#ffffff'
            },
            tooltip: {
                callbacks: {
                    title: context => context[0].raw.text,
                    label: context => {
                        const { originalX, originalY } = context.raw;
                        return `x: ${originalX}, y: ${originalY}`;
                    }
                }
            },
            legend: {
                display: false
            }
        },
        scales: {
            x: {
                display: false,
                min: 0,
                max: 25
            },
            y: {
                display: false,
                min: 0,
                max: 45
            }
        },
        showLine: false
    };


    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Editar sistema</h1>
                    <div className="btn-close-modal" onClick={() => setModalEditarSistema(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div>
                    <div className="modal-content">
                        <Tabs className='mt-3 mb-3'>
                            <Tab eventKey="visao" title={<span>Visão Geral</span>}>
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Sistema</Form.Label>
                                            <Form.Control maxLength={255} defaultValue={EdicaoSistema.nome} onChange={handleChange} name="nome" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Versão</Form.Label>
                                            <Form.Control maxLength={100} defaultValue={EdicaoSistema.versao} onChange={handleChange} name="versao" />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Data Inicial Versão</Form.Label>
                                            <DatePickerComponent allowEdit={false} format='dd/MM/yyyy' value={EdicaoSistema.dataInicialVersao ? new Date(EdicaoSistema.dataInicialVersao) : null} onChange={handleChange} name="dataInicialVersao" placeholder='__/__/____' />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Data Final Versão</Form.Label>
                                            <DatePickerComponent allowEdit={false} format='dd/MM/yyyy' value={EdicaoSistema.dataFinalVersao ? new Date(EdicaoSistema.dataFinalVersao) : null} onChange={handleChange} name="dataFinalVersao" placeholder='__/__/____' />
                                        </Form.Group>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Camada de Impacto no Negócio</Form.Label>
                                            <Form.Select aria-label="Default select example" onChange={handleChange} name="camadaImpactoNegocio">
                                                <option value="0">Selecione</option>
                                                {ImpactoNegocio && ImpactoNegocio?.map((item) => {
                                                    return (
                                                        <option key={item} value={item} selected={item == EdicaoSistema?.camadaImpactoNegocio ? true : false}>
                                                            {item}
                                                        </option>
                                                    )
                                                })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Fornecedor</Form.Label>
                                            <Form.Select aria-label="Default select example" onChange={handleChange} name="fornecedorKey">
                                                <option value="0">Selecione</option>
                                                {Fornecedores && Fornecedores?.map((item) => {
                                                    return (
                                                        <option key={item.id} value={item.key} selected={item?.key == EdicaoSistema?.fornecedor?.key ? true : false}>
                                                            {item.fantasia}
                                                        </option>
                                                    )
                                                })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Descrição</Form.Label>
                                            <Form.Control maxLength={255} defaultValue={EdicaoSistema.descricao} onChange={handleChange} name="descricao" as="textarea" rows={3} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="time" title={<span>Matriz de Avaliação</span>}>
                                <div style={{ height: '400px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
                                    <Scatter ref={chartRef} data={data} options={options} plugins={[quadrants]} />
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditarSistema(false)}>Cancelar</button>
                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                            <button type='button' className="btn-dash btn-criar" style={btnCriar} onClick={(e) => {
                                e.preventDefault();
                                editar();
                            }}>Salvar</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalEditarSistema